import * as UI from "@iyk/music-ui"
import { AppLink } from "@iyk/react-router/client"
import { AppRoutes } from "../../AppRoutes"

export const Logo = ({ interactive }: { interactive: boolean }) => {
  if (interactive) {
    return (
      <AppLink to={AppRoutes.home}>
        <UI.Icon.IykLogo className="size-7" />
      </AppLink>
    )
  }

  return <UI.Icon.IykLogo className="size-7" />
}
